<template>
    <header id="header" class="navbar navbar-expand-lg navbar-fixed navbar-height navbar-container navbar-bordered bg-white">
    <div class="navbar-nav-wrap">
      <!-- Logo -->
      <!-- <a class="navbar-brand" href="/" aria-label="Front">
        <img class="navbar-brand-logo" src="@/assets/logos/LogoCATPD.png" alt="Logo" data-hs-theme-appearance="default">
        <img class="navbar-brand-logo-mini" src="@/assets/logos/logo.png" alt="Logo" data-hs-theme-appearance="default">
      </a> -->
      <!-- End Logo -->

      <div class="navbar-nav-wrap-content-start">
        <!-- Navbar Vertical Toggle -->
        <button type="button" class="js-navbar-vertical-aside-toggle-invoker navbar-aside-toggler">
          <i class="bi-arrow-bar-left navbar-toggler-short-align" data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' data-bs-toggle="tooltip" data-bs-placement="right" title="Collapse"></i>
          <i class="bi-arrow-bar-right navbar-toggler-full-align" data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' data-bs-toggle="tooltip" data-bs-placement="right" title="Expand"></i>
        </button>

        <!-- End Navbar Vertical Toggle -->

         <SearchForm />
        </div>

        <div class="navbar-nav-wrap-content-end">
          <!-- Navbar -->
        <ul class="navbar-nav">
            <!--  @ include('parts.notifications') -->
            <UsersHeader />
          </ul>
          <!-- End Navbar -->
      </div>
    </div>
  </header>
</template>

<script>
import SearchForm from "./SearchForm.vue"
import UsersHeader from "./UsersHeader.vue"
export default {
    name:"HeaderAdmin",
    components:{
      SearchForm,
      UsersHeader
    }
    
}
</script>